import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVerificationUploadPhoto = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "a",
	xmlns: "http://www.w3.org/2000/svg",
	width: 240,
	height: 200,
	viewBox: "0 0 240 200",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".b{fill-rule:evenodd;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M205.03,142.84c1.75,0,3.18-1.43,3.18-3.18s-1.43-3.18-3.18-3.18-3.18,1.43-3.18,3.18,1.43,3.18,3.18,3.18Zm0-5.36c1.2,0,2.18,.98,2.18,2.18s-.98,2.18-2.18,2.18-2.18-.98-2.18-2.18,.98-2.18,2.18-2.18Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M64.92,170.01h-4.24v-4.24c0-.71-.58-1.29-1.29-1.29s-1.29,.58-1.29,1.29v4.24h-4.25c-.71,0-1.29,.58-1.29,1.29s.58,1.29,1.29,1.29h4.25v4.24c0,.71,.58,1.29,1.29,1.29s1.29-.58,1.29-1.29v-4.24h4.24c.71,0,1.29-.58,1.29-1.29s-.58-1.29-1.29-1.29Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M235.75,12.66c-1.26,0-2.27,1.02-2.27,2.27s1.02,2.27,2.27,2.27,2.27-1.02,2.27-2.27-1.02-2.27-2.27-2.27Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M228.11,146.29c-.96,0-1.74,.78-1.74,1.74v23.88h-23.88c-.96,0-1.74,.78-1.74,1.74s.78,1.74,1.74,1.74h25.62c.96,0,1.74-.78,1.74-1.74v-25.62c0-.96-.78-1.74-1.74-1.74Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M228.11,18.11h-25.62c-.96,0-1.74,.78-1.74,1.74s.78,1.74,1.74,1.74h23.88v23.88c0,.96,.78,1.74,1.74,1.74s1.74-.78,1.74-1.74V19.85c0-.96-.78-1.74-1.74-1.74Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M33.56,171.91H9.68v-23.88c0-.96-.78-1.74-1.74-1.74s-1.74,.78-1.74,1.74v25.62c0,.96,.78,1.74,1.74,1.74h25.62c.96,0,1.74-.78,1.74-1.74s-.78-1.74-1.74-1.74Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M33.56,18.11H7.94c-.96,0-1.74,.78-1.74,1.74h0v25.62c0,.96,.78,1.74,1.74,1.74s1.74-.78,1.74-1.74V21.58h23.88c.96,0,1.74-.78,1.74-1.74h0c0-.96-.78-1.74-1.74-1.74Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M153.38,23.47h5.66v5.66c0,.95,.77,1.72,1.72,1.72s1.72-.77,1.72-1.72v-5.66h5.66c.95,0,1.72-.77,1.72-1.72s-.77-1.72-1.72-1.72h-5.66v-5.66c0-.95-.77-1.72-1.72-1.72s-1.72,.77-1.72,1.72v5.66h-5.66c-.95,0-1.72,.77-1.72,1.72s.77,1.72,1.72,1.72Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M139.21,79.17c0-10.21-8.3-18.51-18.5-18.51s-18.5,8.3-18.5,18.51,7.77,17.97,17.51,18.49c.32,0,.63-.01,.95-.01,.34,0,.67,0,1.01,.02,9.75-.5,17.53-8.6,17.53-18.49Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M164.99,55.73c-.39-.44-.79-.87-1.19-1.3-.38-.4-.76-.8-1.16-1.19-.38-.38-.75-.75-1.14-1.11-.39-.37-.79-.74-1.19-1.1-10.63-9.55-24.69-15.37-40.1-15.37s-30.54,6.26-41.3,16.47c-.39,.37-.76,.74-1.14,1.11l-.05,.05c-.79,.79-1.55,1.6-2.29,2.43-.41,.45-.8,.91-1.19,1.38-.01,.02-.03,.03-.04,.05-8.73,10.42-13.98,23.85-13.98,38.5s5.25,28.08,13.98,38.5c.01,.02,.03,.03,.04,.05,.39,.47,.79,.93,1.19,1.38,.74,.83,1.51,1.64,2.29,2.43l.05,.05c.38,.38,.75,.75,1.14,1.11,10.76,10.21,25.29,16.47,41.3,16.47s29.47-5.81,40.1-15.37c.4-.36,.8-.73,1.19-1.1,.39-.37,.76-.74,1.14-1.11,.39-.39,.78-.79,1.16-1.19,.4-.43,.8-.86,1.19-1.3,.42-.47,.83-.95,1.24-1.43,2.18-2.61,4.15-5.4,5.87-8.36,.7-1.2,1.35-2.42,1.97-3.67,3.93-7.98,6.14-16.97,6.14-26.47,0-14.65-5.25-28.08-13.98-38.5-.4-.48-.82-.96-1.24-1.43Zm-12.58,79.56c-1.41,0-2.56-1.15-2.56-2.56,0-16.01-12.75-29.09-28.63-29.62-.32,.01-.64,.02-.97,.02s-.68,0-1.01-.02c-15.9,.51-28.67,13.61-28.67,29.63,0,1.41-1.15,2.56-2.56,2.56s-2.56-1.15-2.56-2.56c0-15.07,9.64-27.93,23.07-32.74-7.06-4.07-11.82-11.7-11.82-20.42,0-12.99,10.57-23.55,23.55-23.55s23.55,10.57,23.55,23.55c0,8.73-4.78,16.37-11.85,20.44,13.41,4.83,23.02,17.67,23.02,32.72,0,1.41-1.15,2.56-2.56,2.56Z"
		})
	]
});
export default SvgVerificationUploadPhoto;
